// Radha — audit trail for tenant settings changes (046). Read-only over the
// existing append-only audit_events (030's pattern), filtered to this entity.
import { useQuery } from "@tanstack/react-query";

import { supabase } from "../lib/supabase";

export interface TenantSettingsAuditEntry {
  id: string; actor_label: string | null; action: string;
  payload: {
    old_upi_vpa?: string | null; new_upi_vpa?: string | null;
    old_pct?: number; new_pct?: number; old_days?: number; new_days?: number;
    old_threshold?: number; new_threshold?: number;
  };
  // NOTE: TENANT_DIRECT_PAY_THRESHOLD_CHANGED reuses old_threshold/new_threshold above.
  created_at: string;
}

export function useTenantSettingsAudit() {
  return useQuery({
    queryKey: ["audit-events", "tenants"],
    queryFn: async (): Promise<TenantSettingsAuditEntry[]> => {
      const { data, error } = await supabase
        .from("audit_events")
        .select("id, actor_label, action, payload, created_at")
        .eq("entity_type", "tenants")
        .order("created_at", { ascending: false })
        .limit(15);
      if (error) throw error;
      return (data ?? []) as unknown as TenantSettingsAuditEntry[];
    },
  });
}
